export const PLACEHOLDER_NOME_CERTIFICADO = 'Seu Nome Aqui'

export const nomeCertificadoEstaVazio = (nome?: string): boolean =>
  !nome?.trim()

export const textoNomeNoCertificado = (nome?: string): string => {
  const valor = nome?.trim()
  return valor || PLACEHOLDER_NOME_CERTIFICADO
}
